/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_persons_create_invitation_drawer_description = /** @type {(inputs: {}) => string} */ () => {
	return `Completa la información para enviar una invitación a un nuevo miembro`
};

const en_persons_create_invitation_drawer_description = /** @type {(inputs: {}) => string} */ () => {
	return `Complete the information to send an invitation to a new member`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const persons_create_invitation_drawer_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.persons_create_invitation_drawer_description(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("persons_create_invitation_drawer_description", locale)
	if (locale === "es") return es_persons_create_invitation_drawer_description(inputs)
	return en_persons_create_invitation_drawer_description(inputs)
};
export { persons_create_invitation_drawer_description as "persons.create_invitation.drawer_description" }